import type { NavigationGuard } from 'vue-router'
import { EPage } from '@/shared/enum/page.enum'
import { usePackageStore } from '@/stores/package'
import { isMandatoryBilling } from '@/business-rules'
import { useAppStore } from '@/stores/app'

export const mandatoryBillingGuard: NavigationGuard = (_to, _from, next) => {
  const packageStore = usePackageStore()
  const appStore = useAppStore()
  if (
    !packageStore.packageSelected ||
    !isMandatoryBilling(appStore.country, packageStore.packageSelected.value)
  ) {
    next(EPage.PACKAGES)
    return
  }

  next()
  return
}
